import type { RecursiveRequired, Settings } from '#/global'
import { cloneDeep } from 'es-toolkit'
import settingsDefault from '@/settings.default'
import { merge } from '@/utils/object'

const globalSettings: Settings.all = {
  app: {
    lightTheme: 'neutral',
    darkTheme: 'neutral',
    radius: 0,
    enablePermission: true,
    enableDynamicTitle: true,
    enableFeedback: true,
    enableErrorLog: true,
    enableCheckUpdates: true,
    routeBaseOn: 'backend',
  },
  layout: {
    enableMobileAdaptation: true,
  },
  menu: {
    enableSubMenuCollapseButton: true,
    enableHotkeys: true,
  },
  topbar: {
    mode: 'fixed',
  },
  tabbar: {
    enable: true,
    style: 'fashion',
    enableIcon: false,
    enableMemory: true,
    enableHotkeys: true,
  },
  toolbar: {
    enable: false,
    fullscreen: true,
    pageReload: true,
    colorScheme: true,
  },
  breadcrumb: {
    enableMainMenu: true,
  },
  userPreferences: {
    enable: true,
  },
  copyright: {
    enable: true,
    dates: 'V20220615',
    company: '云研科技 界面设计及代码受知识产权保护 抄袭必究',
  },
}

export default merge(globalSettings, cloneDeep(settingsDefault)) as RecursiveRequired<Settings.all>
